export const rainDrops = [
    {
        file: 'meiguo',//美国
        user: '哄咩',
        position: '美国宾夕法尼亚州-State College',
        time: '2014.5.21',
        content: '记得是暑期学期刚开始的一天，傍晚的时候，我一个人在公交车站亭等40分钟来一趟且习惯性晚点的公交车，雨突然下得很大，但是亭子把雨挡得很严实。躲在亭子里听着雨声就突然觉得周围的世界静得让人很安心。'
    },
    {
        file: 'yidali',//意大利
        user: 'Echo',
        position: '意大利拉斯佩齐亚开往威尼斯的途中',
        time: '2017年夏',
        content: '这是四个大人与一个孩子的旅行，自驾途中遇上暴雨夹带冰雹。旅行之于我的意义就在这些途中奇遇，经历的这些事，让我看到更真实的自己，更深刻地认识自己，反省自己，完善自己。'
    },
    {
        file: 'miandian',//缅甸
        user: '民辅',
        position: '缅甸曼德勒',
        time: '2017.8.6 凌晨2：56',
        content: '已经不知道连续加了多少天班了，偶尔有雨声来作伴到也显得不那么孤单，画图狗的悲哀...'
    },
    {
        file: 'jiapeng',//加蓬
        user: 'Sahara',
        position: '加蓬利伯维尔',
        time: '2017.8.6',
        content: '一年前的今天，也有一场大雨，我和前男友在雨中拥吻，那是初吻的记忆。'
    },
    {
        file: 'ruidian',//瑞典
        user: 'yuki',
        position: '瑞典斯德哥尔摩',
        time: '2017.8.6',
        content: '瑞典的彩虹游行昨天刚结束，雨声让昨天的热闹归于平静，在这个雨天里，希望每个相爱的人都终成眷属，愿世界都能被善意与温柔相待。'
    },
    {
        file: 'riben',//日本
        user: '海边的卡夫卡卡卡卡卡',
        position: '日本神户',
        time: '2017.8.7',
        content: '立秋的雨水真是来得勤快啊！我一个激灵翻身起床拿起资料开始备注今天要消化的学习内容。与雨为伴的也许还有台风君！不知道它会不会来……整个城市像笼罩着一层轻烟。'
    },
    {
        file: 'gesidalijia',//哥斯达黎加
        user: '凌嫣',
        position: '哥斯达黎加圣克鲁斯',
        time: '2017.8.6',
        content: '这场关于雨的录音征集开始时，我刚好在圣克鲁斯参加国际志愿者的海龟保护活动。每天傍晚到深夜，一定会暴雨。听听异国他乡的雨声，有不同吗？'
    },
    {
        file: 'yingguo',//英国
        user: '＼(^o^)／ 悦己',
        position: '英国德比郡查茨沃斯庄园',
        time: '2017.8.8',
        content: '我在英国德比郡，那个拍傲慢与偏见的庄园。带着苗，在英国度假。苗13岁。'
    },
    {
        file: 'taiguo',//泰国
        user: '不歸',
        position: '泰国普吉岛',
        time: '2017.8.9',
        content: '暴雨忽降，从酒店阳台望出是寥落的行人和昏黄的灯光。旁边坐着一个即将离开不知归期的男生。会想念异国的这一刻静默。“寒蝉凄切”。X&R。'
    },
    {
        file: 'hanguo',//韩国
        user: '洋葱卿',
        position: '韩国京畿道',
        time: '2017.8.15',
        content: '在答辩前夜下的一场大雨，本来紧张和焦虑得没有入睡感，却听着这大雨声，车来车往的溅水声，屋檐的滴答声，让我的心平静了许多~尽力而为！'
    },
    {
        file: 'santanyingyue',//三潭映月
        user: '蔓延',
        position: '浙江杭州西湖区西溪',
        time: '2017.8.8',
        content: '这是杭州久违的一场暴雨，我是早上在公交车上看到新世相的雨声博物馆，没想到晚上就下雨了，还是一场好大的暴雨。伴着惊雷，就这样在我的小出租房里，一个人靠着窗边，听雨，听雷。突然控制不住的想起了前任，那是唯一一次也是最后一次，挽着他的手臂，撑着我的大黑伞，一起去吃了重庆小面。'
    },
    {
        file: 'kongzi',//孔子
        user: '子非鱼',
        position: '山东德州',
        time: '2017.08.12',
        content: '下午忽然下了雷阵雨。站在院子里，风雨尚未取走夏日的灼灼暑气。敲在红色砖石上沉郁地响，打在碧绿的叶子上清脆地响。雨与音乐，这是我最爱的两样。希望这雨能下得更久一些吧。'
    },
    {
        file: 'zhongebianjingshi',//中俄边境石
        user: 'Lee',
        position: '黑龙江黑河市大黑河岛边',
        time: '2016年8月',
        content: '眼前是俄罗斯颜色鲜艳的高楼，背后是大黑河岛森林公园的围栏。我坐在黑龙江边突出的河堤台阶上，我听着江水声风雨声，在江边呆坐了一整个下午。8月的东北已有些凉意，当时我正处在两份工作的间隔期，一身轻松，背起包一口气跑到边境，什么都不用想，就这样静静地享受雨声带来的平静。'
    },
    {
        file: 'niaocao',//鸟巢
        user: '贾一凡',
        position: '北京街头',
        time: '2016.7.20夜',
        content: '因为要准备考试，复习到很晚。一个人在雨中往回去的方向走，这时候看到路灯下美妙的一幕，像花丝绽放，像流星穿越，那么安静而有节奏，就像一场奇异的哑剧。毋庸置疑，好的事情总会到来。而当它来晚时，也不失为一个惊喜。'
    },
    {
        file: 'diwangdasha',//地王大厦
        user: '小和尚',
        position: '深圳凤凰山',
        time: '2016.4.4',
        content: '刚翻到手机的一段录音，是在深圳凤凰山录下的。那是周末的某天下午，狂风大作，暴雨顷刻而至，趴在阳台上录制了这段雨声。现在想来，当时必然满心欢喜的。'
    },
    {
        file: 'shaolingshi',//少林寺
        user: '﹎M!ss.Mango.',
        position: '河南郑州',
        time: '2017.8 立秋',
        content: '这是立秋的雨，今天也是周一，心情有点糟糕，下定决心结束现在的生活状态，换一种自己愉快的生活方式，无论太阳是否灿烂，不要让自己过得不开心。即使前进的道路上布满荆棘，也要勇敢向着自己的目的地前进。如果屏幕前的你也看到，记得开心哦～'
    },
    {
        file: 'banya',//板鸭
        user: 'Hiker',
        position: '江苏南京龙王山下',
        time: '2017.07.10',
        content: '那是刚刚过去的这个学期里在校的最后一天，做完社会实践，下了我在南京见过的可能是最大的雨，早晨起来的时候要赶早班车的舍友已经回家了。我在离校前帮她把一大纸箱东西寄回了家，然后把留了两年的及腰的头发剪去了不是很多，但足以有所改变的三十公分。'
    },
    {
        file: 'hongcun',//宏村
        user: '遇见',
        position: '安徽合肥',
        time: '2017.7.9晚',
        content: '喜欢的男孩约我出去，其实脚受伤了，真疼啊，但心里却暗暗希望时间过得慢些再慢些，这条路永远不要走到头。然后一天都在下暴雨，晚上拖着病脚躺在床上，外面雨声很大，房间很安静，想到他，又甜蜜又心酸。'
    },
    {
        file: 'qixingwan',//七星湾
        user: '氵氵氵',
        position: '台湾花莲七星湾',
        time: '2017.3',
        content: '我们去台湾花莲七星潭那天，又大风又下雨，被风刮到说不出话，推小车卖小吃的老板和我们说了好多，不记得了，只记得人很好，吃了个炸弹葱油饼，然后被袭来的浪吓到，现在录音里都是尖叫声。那是在台湾旅行的倒数第二天。'
    },
    {
        file: 'feng',//风
        user: '豆豆皮皮',
        position: '浙江东极岛',
        time: '2017.7',
        content: '这不是一场雨，是一场风，来自东极岛东福山，呼呼的风声。一个人站在山顶，太平洋的风儿刮向我，美极了。'
    },
    {
        file: 'caoyuan',//草原
        user: 'Misscloudby',
        position: '内蒙宁夏交界通湖草原',
        time: '2017.8.6',
        content: '雨声来自从内蒙古通湖草原回家的路上。突发感情问题，结果一言不合直奔大草原。看到美丽的草原日出，一切都是那么fresh。回程路上的过路雨很急，洗涤着大地。感恩，愿一切安好。'
    },
    {
        file: 'huoguo',//火锅
        user: '未雪',
        position: '重庆',
        time: '2017年夏',
        content: '一段四年的感情，挣扎、痛苦，终于下定决心划清界限。就是那么一天夜晚，下了很大的雷雨，到处打不到车，朋友没有带伞，我去轻轨站接她。雷声和雨声快要把我们淹没，比起往日的车马喧嚣，反倒觉得宁静起来。雨声总是能带给人藉慰，仿佛在寒凉中生出一种暖意。给人重新开始的理由。'
    },
    {
        file: 'jiuxianshan',//九仙山
        user: '.',
        position: '九仙山',
        time: '2017.8',
        content: '到这里4个月了，从开始的慌乱到现在的驾轻就熟，这个过程中放弃了一些，但是也一直在坚持着。希望以后安好。'
    },
    {
        file: 'reganmian',//热干面
        user: ' Apple-green',
        position: '湖北武汉华中科技大学',
        time: '2017.8.12',
        content: '雨里的电动车在大雨中狂叫。《一程山路》笑着你也笑着我，你离开时雨声哭得很大很响，夜里思念悠长如寂寞的雨巷。'
    },
    {
        file: 'tengwangge',//滕王阁
        user: '邱邱',
        position: '江西南昌高速',
        time: '2017.8.13',
        content: '我在江西南昌高速。高速六车追尾，大堵。'
    },
    {
        file: 'dalisanta',//大理三塔
        user: 'Acute.魔王阿亮',
        position: '云南大理苍山洱海旁',
        time: '2017.8.15',
        content: '在北京听着雨声觉得宁静安详，回到家乡，听着雨声却是浓浓的思念，雨声影响的心境，竟因在谁身旁。'
    },
    {
        file: 'xinjianghuamao',//新疆花帽
        user: '碧海蓝天',
        position: '新疆乌鲁木齐',
        time: '2017.8.6 凌晨1点半',
        content: '我在新疆乌鲁木齐，刚好外面在下雨。我最难忘的和雨有关的事，就是大学时，和宿舍的人共打一把伞，穿着凉拖，在大雨中向教室走去，简单而快乐。'
    },
    {
        file: 'xiaolongtangbao',//小笼汤包
        user: '懒 懒',
        position: '江苏无锡',
        time: '2017立秋',
        content: '晚上打雷下雨，没带伞躲在屋檐下，给同城的男朋友发消息，他明知道生理期，还回复我说：“夏天没关系的，凉爽！”坐在地铁里瑟瑟发抖的时候才确定，他是真的不爱我不在乎我啊！失业的同时我失恋了！'
    },
    {
        file: 'dongfangmingzhu',//东方明珠
        user: '周娟',
        position: '上海浦东新区',
        time: '2017.8.8',
        content: '在上海浦东新区他新租的房子里，他在上班，我上午把房子里里外外打扫了一遍，累瘫在床上，一觉醒来，发现外面大雨。于是很兴奋录了下来，今天是我们在一起5周年的日子，异地了5年，现在终于在一个城市了。'
    },
    {
        file: 'touming',//透明
        user: '我',
        last: true,
        position: '',
        time: '',
        content: ''
    },
];
export const dropTypes = rainDrops.map(x => x.file);
/*
{
	file: '',
		user: '',
	position: '',
	time: '',
	content: ''
},
*/


// WEBPACK FOOTER //
// ./src/stage/scene/drops/dropTypes.js